module.exports = __webpack_public_path__ + "img/logo.4451d1d5.png";